// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3TpX2","col":"CardReaderDesc_col__c1-FS","label":"CardReaderDesc_label__2Qfzh"};